const PROTOCOL_VERSION = 1
const MESSAGE_TYPES = Object.freeze({
  READY: 'IN_TRANSIT_READY',
  TOKEN: 'IN_TRANSIT_TOKEN',
  COMMAND: 'IN_TRANSIT_COMMAND',
  EVENT: 'IN_TRANSIT_EVENT',
  RESIZE: 'IN_TRANSIT_RESIZE'
})
const VALID_TYPES = new Set(Object.keys(MESSAGE_TYPES).map(key => MESSAGE_TYPES[key]))

function normalizeOrigin(value) {
  if (typeof value !== 'string' || value !== value.trim() || value.includes('*')) {
    throw new Error('允许的 Origin 格式不正确')
  }
  let parsed
  try {
    parsed = new URL(value)
  } catch (error) {
    throw new Error('允许的 Origin 格式不正确')
  }
  if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password ||
      parsed.search || parsed.hash || parsed.pathname !== '/') {
    throw new Error('允许的 Origin 格式不正确')
  }
  return parsed.origin
}

function validIdentifier(value) {
  return typeof value === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(value)
}

function createRequestId() {
  const bytes = new Uint8Array(16)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
    return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

function createEmbedSession(options) {
  const parentWindow = options && options.parentWindow
  const allowedOrigin = normalizeOrigin(options && options.allowedOrigin)
  const handshakeId = options && options.handshakeId
  const onMessage = options && typeof options.onMessage === 'function'
    ? options.onMessage
    : () => {}
  if (!parentWindow || !validIdentifier(handshakeId)) {
    throw new Error('嵌入握手参数不正确')
  }

  return {
    accept(event) {
      const data = event && event.data
      if (!event || event.source !== parentWindow || event.origin !== allowedOrigin ||
          !data || typeof data !== 'object' || data.version !== PROTOCOL_VERSION ||
          data.handshakeId !== handshakeId || !validIdentifier(data.requestId) ||
          !VALID_TYPES.has(data.type)) return false
      onMessage(data)
      return true
    },
    message(type, payload = {}) {
      if (!VALID_TYPES.has(type)) throw new Error('嵌入消息类型不正确')
      return {
        ...payload,
        type,
        version: PROTOCOL_VERSION,
        handshakeId,
        requestId: createRequestId()
      }
    },
    getAllowedOrigin() {
      return allowedOrigin
    }
  }
}

module.exports = {
  PROTOCOL_VERSION,
  MESSAGE_TYPES,
  createEmbedSession,
  createRequestId,
  normalizeOrigin
}
